import { useTagStore, jsonHeaders } from "./tag-store.js";
import {
  userRecipeTagPath,
  userRecipeTagsPath,
  bulkDestroyUserRecipeTagsPath,
  countUserRecipeTagsPath,
  prototypeUserRecipeTagsPath,
  bulkAddUserRecipeTagsPath,
  bulkRemoveUserRecipeTagsPath,
} from "routes";

export const useRecipeTagStore = () => {
  return useTagStore({
    modelName: "recipe",
    tagModelName: "recipe_tag",
    tagPath: userRecipeTagPath,
    countTagsPath: countUserRecipeTagsPath,
    tagsPath: userRecipeTagsPath,
    bulkDestroyTagsPath: bulkDestroyUserRecipeTagsPath,
    prototypeTagsPath: prototypeUserRecipeTagsPath,
    additionalActions: {
      async bulkAddTags({ ids, tagNames }) {
        await fetch(bulkAddUserRecipeTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ recipe_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
      },

      async bulkRemoveTags({ ids, tagNames }) {
        await fetch(bulkRemoveUserRecipeTagsPath(this.userId), {
          method: "POST",
          headers: jsonHeaders,
          body: JSON.stringify({ recipe_ids: ids, tags: tagNames }),
        });

        await this.loadAllTags();
      },
    },
  });
};
